import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const LIST_FAIL = "PARTNERSHIP:LIST_FAIL";

export interface ListFailAction extends Action {
  type: typeof LIST_FAIL;
  organization: OrganizationKeyName;
}

export const listFailAction = (
  organization: OrganizationKeyName
): ListFailAction => ({
  type: LIST_FAIL,
  organization,
});
